import { Quote, Star } from "lucide-react";
import PageHeader from "@/components/PageHeader";

const testimonials = [
  {
    name: "James M.",
    location: "Juja",
    text: "Patrick fixed my car in Juja while I was at work! Professional service with a proper diagnostic report. Highly recommended.",
    rating: 5,
  },
  {
    name: "Grace W.",
    location: "Section 9, Thika",
    text: "The pre-purchase inspection saved me from buying a lemon. Their 150-point check is incredibly thorough. Worth every shilling!",
    rating: 5,
  },
  {
    name: "David K.",
    location: "Landless, Thika",
    text: "My car broke down on Nanyuki Road and they were there within 30 minutes. Fast, honest, and very skilled engineers.",
    rating: 5,
  },
  {
    name: "Mary N.",
    location: "Thika Town",
    text: "Best mobile mechanic in Thika! They service my fleet vehicles monthly. Reliable and always on time.",
    rating: 5,
  },
  {
    name: "Peter O.",
    location: "Juja",
    text: "I love that they use professional diagnostic tools. No guesswork — they showed me the data on screen and explained everything clearly.",
    rating: 5,
  },
  {
    name: "Catherine A.",
    location: "Section 9, Thika",
    text: "My brakes were making terrible noises. Patrick came, fixed them same day, and the price was very fair. True professionals!",
    rating: 4,
  },
];

const Testimonials = () => (
  <>
    <PageHeader title="What Our Clients Say" subtitle="Real reviews from real drivers across Thika and Juja" breadcrumb="Testimonials" />

    <section className="section-padding bg-background relative overflow-hidden">
      <div className="absolute top-20 right-0 w-72 h-72 bg-primary/3 rounded-full blur-[120px]" />
      <div className="absolute bottom-20 left-0 w-60 h-60 bg-orange-glow/3 rounded-full blur-[100px]" />
      
      <div className="container mx-auto max-w-5xl relative z-10">
        {/* Featured testimonial */}
        <div className="bg-charcoal-gradient rounded-xl p-6 sm:p-10 mb-8 sm:mb-10 relative overflow-hidden noise-overlay shadow-elevated">
          <div className="absolute top-0 right-0 w-48 h-48 bg-primary/5 rounded-full blur-[80px]" />
          <div className="relative z-10">
            <Quote className="h-8 w-8 sm:h-10 sm:w-10 text-primary/30 mb-4" />
            <p className="text-secondary-foreground text-base sm:text-lg md:text-xl leading-relaxed mb-6 italic">
              "{testimonials[0].text}"
            </p>
            <div className="flex items-center gap-1 mb-3">
              {[...Array(5)].map((_, j) => (
                <Star key={j} className="h-4 w-4 fill-primary text-primary" />
              ))}
            </div>
            <p className="font-heading uppercase tracking-wider text-primary text-sm sm:text-base">{testimonials[0].name}</p>
            <p className="text-silver/60 text-xs sm:text-sm">{testimonials[0].location}</p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {testimonials.slice(1).map((t, i) => (
            <div key={i} className="bg-card border border-border/50 rounded-xl p-5 sm:p-7 hover:border-primary/40 hover:shadow-elevated transition-all duration-500 group hover:-translate-y-1 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/3 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="relative z-10">
                <Quote className="h-5 w-5 text-primary/25 mb-3" />
                <p className="text-foreground text-sm leading-relaxed mb-5 italic">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} className={`h-3 w-3 ${j < t.rating ? "fill-primary text-primary" : "text-border"}`} />
                  ))}
                </div>
                <p className="font-heading uppercase tracking-wider text-primary text-xs sm:text-sm">{t.name}</p>
                <p className="text-muted-foreground text-[10px] sm:text-xs">{t.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Testimonials;
